'use client';

import { useState, type ReactNode } from 'react';
import {
  RequestLanguageContext,
  applyDocumentLang,
  useLanguageStore,
  type Language,
} from '../stores/languageStore';

interface LanguageHydratorProps {
  initial: Language;
  children: ReactNode;
}

// WHY: сидировать в инициализаторе useState, не в useEffect — иначе первый клиентский рендер расходится с SSR и мигает
// перевод
export function LanguageHydrator({ initial, children }: LanguageHydratorProps) {
  useState(() => {
    const current = useLanguageStore.getState().language;
    if (current !== initial) {
      useLanguageStore.setState({ language: initial });
    }
    applyDocumentLang(initial);
    return true;
  });
  return <RequestLanguageContext.Provider value={initial}>{children}</RequestLanguageContext.Provider>;
}
